export default __webpack_public_path__ + "static/media/AmandaBaroni_03.853b2b79.jpg";